import { RouteType } from "types/RouteType";

const detailingPipelineRoute: RouteType = {
  name: "MM Pipeline",
  path: "/mm/pipeline",
  layout: "/app",
  viewportCard: {
    header: {
      // "DE Pipeline" (Creede, 2026-10-27): "that way it matches everything else."
      title: "DE Pipeline",
      component: () => import("./DetailingPipeline.Header"),
      enableRefreshButton: false,
      enableBackButton: false,
    },
    body: {
      component: () => import("./DetailingPipeline.Body"),
      grayBackground: true,
    },
  },
  group: "Miller-Mize",
  menuOrder: 3,
  requiresAuth: true,
  requiresPermission: false,
  dialogs: [
    {
      name: "Edit Pipeline Card",
      title: "Edit Project Details",
      component: () => import("./DetailingPipelineDialogs/PipelineCardDialog"),
    },
  ],
};

export default detailingPipelineRoute;
